export const getInsurers = api => async () => await api.get("/api/insurers/")
